module.exports = [
  require('./ray_of_sickness'),
  require('./remove_curse'),
  require('./rope_trick'),
]
